module.exports = __webpack_public_path__ + "img/platform_fw.18608a97.png";